import { render, staticRenderFns } from "./TopicCard.vue?vue&type=template&id=0876ca14"
import script from "./TopicCard.vue?vue&type=script&lang=js"
export * from "./TopicCard.vue?vue&type=script&lang=js"
import style0 from "./TopicCard.vue?vue&type=style&index=0&id=0876ca14&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports